import type {FilterObject} from 'nutshell-core/types';

/*
 * Transform createdTime to closedTime
 */
export function getTransformedFilters(filters: Array<FilterObject>): Array<FilterObject> {
    return filters.map((item) => {
        if ('createdTime' in item) {
            const {createdTime, ...rest} = item;

            return {closedTime: createdTime, ...rest};
        }

        return item;
    });
}

/*
 * For the sales report, we need to add the origin and status filters,
 * and switch the created time to closed time.
 */
export function addReportSpecificFilters(filters: Array<FilterObject>): Array<FilterObject> {
    const chatOrigin = NutshellFrontendSettings.originApiIdChat;
    const chatbotOrigin = NutshellFrontendSettings.originApiIdChatbot;
    const offlineFormOrigin = NutshellFrontendSettings.originApiIdOfflineForm;

    const originData = [chatOrigin, chatbotOrigin, offlineFormOrigin]
        .filter(Boolean)
        .map((origin) => ({data: origin}));

    const transformedFilters = getTransformedFilters(filters);

    return [...transformedFilters, {origin: originData}, {status: 'won'}];
}
